import styled from "styled-components";
import { Modal } from "antd";
import {
  FONT_SIZE,
  SCALE_BY_DISPLAY_SIZE,
  ROW_HEIGHT_ORG_CHART,
  BUTTON_HEIGHT_ORG_CHART,
  TEXT_SCALE_PROPS,
} from "@lhd/constants";
import { DISPLAY_SIZES } from "@lhd/types";

export const ModalWrapper = styled(Modal)<any>`
  .ant-modal-header,
  .ant-modal-close-x {
    display: none;
  }

  .ant-modal {
    top: 400px;
  }

  .ant-modal-content {
    border-radius: 8px;
  }

  .ant-modal-body {
    padding-top: 40px;

    > p {
      display: flex;
      justify-content: center;
      align-items: center;
      text-align: center;
      margin-bottom: 0;
      font-size: ${({ text_scale }) =>
        FONT_SIZE[
          (text_scale || DISPLAY_SIZES.SMALL) as keyof typeof FONT_SIZE
        ]};
      font-weight: 600;
      white-space: pre-line;
    }
  }

  .ant-modal-footer {
    display: flex;
    justify-content: center;
    align-items: center;
    gap: 10px;
    padding: 0;
    padding: 10px;

    button {
      border-radius: 8px;
      border: 0;
      cursor: pointer;
      width: ${({ text_scale }) =>
        `${Math.round(
          100 *
            SCALE_BY_DISPLAY_SIZE[
              (text_scale ||
                DISPLAY_SIZES.SMALL) as keyof typeof SCALE_BY_DISPLAY_SIZE
            ],
        )}px`};
      height: ${({ text_scale }) =>
        `${
          BUTTON_HEIGHT_ORG_CHART[
            (text_scale ||
              DISPLAY_SIZES.SMALL) as keyof typeof BUTTON_HEIGHT_ORG_CHART
          ]
        }px` || "32px"};
      padding: 6px;
      color: #ffffff;
      text-align: center;
      font-size: ${({ text_scale }) =>
        FONT_SIZE[
          (text_scale || DISPLAY_SIZES.SMALL) as keyof typeof FONT_SIZE
        ]};
      display: flex;
      align-items: center;
      justify-content: center;
    }
  }

  .button-cancel {
    border: 1px solid #d9d9d9 !important;
    background: #fff !important;
    color: rgba(0, 0, 0, 0.85) !important;
  }
  .text-left {
    text-align: left !important;
  }
`;
